import React from 'react'
import { useSelector } from 'react-redux'
import { Alert, Slide, AlertTitle } from '@mui/material'
import { styled } from '@mui/system'
import { useTheme } from '@mui/material/styles'

const NotificationContainer = styled('div')({
  position: 'absolute',
  right: 20,
  top: 88,
  zIndex: 9999
})

const SlideTransition = (props) => {
  return <Slide {...props} direction="left" />
}

const color = [
  {
    type: 'success',
    color: '#cce8cd'
  },
  {
    type: 'error',
    color: '#f4c7c7'
  },
  {
    type: 'warning',
    color: '#ffe2b7'
  },
  {
    type: 'info',
    color: '#b8e7fb'
  }
]

const Notification = ({ notification }) => {
  return (
    <Alert
      severity={notification.type}
      icon={notification.icon}
      variant="outlined"
      sx={{
        mb: 1,
        width: notification.width,
        whiteSpace: 'pre-wrap',
        backgroundColor: '#2c2c2c',
        boxShadow: '0 0 10px 0 rgba(0, 0, 0, 0.5)',
        borderColor: color.find((c) => c.type === notification.type).color,
        color: color.find((c) => c.type === notification.type).color,
        fontFamily: 'Poppins, sans-serif'
      }}
    >
      <AlertTitle>{notification.type.toUpperCase()}</AlertTitle>
      {notification.message}
    </Alert>
  )
}

const NotificationList = () => {
  const notifications = useSelector((state) => state.notification.notifications)
  return (
    <NotificationContainer>
      {notifications.map((notification, index) => (
        <SlideTransition key={index} in={notification.visible}>
          <div>
            <Notification notification={notification} />
          </div>
        </SlideTransition>
      ))}
    </NotificationContainer>
  )
}

export default NotificationList
